// @flow
import * as React from 'react';
import usePromise from 'react-promise';

type Props = {
    promise: Function,
    then: (response: Object) => React.Node,
}

const Async = (props: Props) => {
    const { value, loading } = usePromise<string>(props.promise);
    if (loading) return null;
    return props.then(value);
};

export default Async;
